type RateDisplayFormat = "net" | "gross" | "advertised";

type DailyDepositPrefs = {
  filters?: {
    rateDisplay?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

const STORAGE_KEY = "daily_deposit_prefs_v1";
const DEFAULT_RATE_DISPLAY: RateDisplayFormat = "net";
const VALID_RATE_DISPLAYS = new Set<RateDisplayFormat>(["net", "gross", "advertised"]);

const settingsPage = document.querySelector<HTMLElement>("[data-daily-deposit-settings]");
const rateSelect = document.querySelector<HTMLSelectElement>("[data-rate-display-select]");
const saveButton = document.querySelector<HTMLButtonElement>("[data-rate-display-save]");

function normalizeRateDisplay(value: unknown): RateDisplayFormat {
  return VALID_RATE_DISPLAYS.has(value as RateDisplayFormat)
    ? (value as RateDisplayFormat)
    : DEFAULT_RATE_DISPLAY;
}

function readPrefs(): DailyDepositPrefs {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as unknown;
    return parsed && typeof parsed === "object" ? (parsed as DailyDepositPrefs) : {};
  } catch {
    return {};
  }
}

function readRateDisplay(): RateDisplayFormat {
  return normalizeRateDisplay(readPrefs().filters?.rateDisplay);
}

function writeRateDisplay(nextRateDisplay: RateDisplayFormat): void {
  const prefs = readPrefs();
  prefs.filters = {
    ...(prefs.filters || {}),
    rateDisplay: nextRateDisplay,
  };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
}

function syncSelect(): void {
  if (!rateSelect) {
    return;
  }
  rateSelect.value = readRateDisplay();
}

syncSelect();

saveButton?.addEventListener("click", () => {
  if (!rateSelect) {
    return;
  }
  const nextRateDisplay = normalizeRateDisplay(rateSelect.value);
  rateSelect.value = nextRateDisplay;
  writeRateDisplay(nextRateDisplay);
  if (settingsPage?.dataset.returnUrl) {
    window.location.href = settingsPage.dataset.returnUrl;
  }
});

window.addEventListener("storage", (event) => {
  if (event.key === STORAGE_KEY) {
    syncSelect();
  }
});

export {};
